import ConfirmDialog from './ConfirmDialog';
import type { ModalProps } from './type';

const MobileModal = (props: ModalProps) => <ConfirmDialog {...props} isMobile />;

export default MobileModal;
